export default __webpack_public_path__ + "static/media/skillsearch.984b023b.png";